
// const resource = 'https://heylinkapi.com/connect/v1/callbacks/advertisers'
const resource = '/shop/heylinkapi/advertisers'

export default ($axios) => ({

  /**
   * post data to heylink api
   * @param {object} body
   * @returns axios
   */
  send(body) {
    return $axios.post(resource, body)
  }

})
